import * as types from './actionTypes';

// Regular action creators
export function fetchDataForDashboard() {
  return {
    type: types.FETCH_DASHBOARD_REQUEST,
  };
}

export function fetchDataForDashboardSuccess({ data }) {
  return {
    type: types.FETCH_DASHBOARD_SUCCESS,
    data,
  };
}

export function fetchDataForDashboardFail({ error }) {
  return {
    type: types.FETCH_DASHBOARD_FAIL,
    error,
  };
}

export function fetchUnpaidContractsForDashboard() {
  return {
    type: types.FETCH_UNPAID_CONTRACTS_REQUEST,
  };
}

export function fetchUnpaidContractsForDashboardSuccess({ data }) {
  return {
    type: types.FETCH_UNPAID_CONTRACTS_SUCCESS,
    data,
  };
}

export function fetchUnpaidContractsForDashboardFail({ error }) {
  return {
    type: types.FETCH_UNPAID_CONTRACTS_FAIL,
    error,
  };
}